import type { ArtifactItem } from '@eriko/shared-types';
import { create } from 'zustand';

interface ConvArtifactState {
  artifacts: ArtifactItem[];
  activeIndex: number | null;
  addArtifact: (artifact: ArtifactItem) => void;
  setActiveIndex: (index: number | null) => void;
  reset: () => void;
}

export const useConvArtifactStore = create<ConvArtifactState>((set) => ({
  artifacts: [],
  activeIndex: null,
  addArtifact: (artifact) =>
    set((s) => {
      const next = [...s.artifacts, artifact];
      return { artifacts: next, activeIndex: next.length - 1 };
    }),
  setActiveIndex: (index) => set({ activeIndex: index }),
  reset: () => set({ artifacts: [], activeIndex: null }),
}));
